export enum ControlLabelAlignment {
  Top,
  Left,
}
